module.exports = __webpack_public_path__ + "static/media/crown@about.58a7e6df.png";